import { RefObject } from 'react';
import { ViewIds } from '@ardoq/api-types';
import type { ExportConfigParams } from '@ardoq/view-settings';
import { getExportsForHtmlView } from '@ardoq/export';
import type { I18nLocale } from '@ardoq/i18n';
import { trackExportingVisualization } from 'tracking/events/visualizations';
import { addToPresentation as addToPresentationFn } from 'viewSettings/exportHandlers';
import { getStyleSheets } from 'tabview/getSharedExportFunctions';
import { getExportLabels } from 'views/getExportLabels';

const getExportSettings = (
  viewId: ViewIds,
  containerRef: RefObject<HTMLElement | null>,
  i18nLocale: I18nLocale
): ExportConfigParams => {
  const { exportToPng, addToPresentation } = getExportsForHtmlView({
    container: () => containerRef.current,
    exportedViewMetadata: {
      name: viewId,
      isViewpointMode: false,
    },
    trackingFunction: trackExportingVisualization,
    addToPresentation: addToPresentationFn,
    getStyleSheets,
    labels: getExportLabels(i18nLocale),
  });

  return {
    addToPresentation,
    exportToPng,
  };
};

export { getExportSettings };
